import React, { memo } from "react";
import { TextArea } from "@progress/kendo-react-inputs";

import AttachmentUploader from "../AttachmentUploader/AttachmentUploader";
import CommonCard from "src/components/Card/Card";

import SectionHeader from "./SectionHeader";
import { DescriptionIcon, PaperclipIcon } from "./icons";
import { getMetricColor, hexToRgba, METRIC } from "src/components/MultiDateTimeCalendar/calendarUtils";

/* Free-text description and supporting attachments — both optional. */
const OptionalDetailsSection = ({
  description,
  onDescriptionChange,
  onDescriptionBlur,
  attachments = [],
  onAttachmentsAdd,
  onAttachmentRemove,
  attachmentStatuses = {},
  maxSizeMB = 10,
  disabled = false,
  isShiftContract = false,
}) => {
  // Same threshold-type colouring as the Contractual Details icons.
  const accentColor = getMetricColor({ value: isShiftContract ? METRIC.QUANTITY : METRIC.HOURS });
  const accentStyle = {
    "--accordion-accent": accentColor,
    "--accordion-accent-bg": hexToRgba(accentColor, 0.12),
  };

  return (
    <section className="add-pay-request__section" style={accentStyle}>
      <CommonCard className="add-pay-request__card">
        <div style={{ padding: "8px 0px 8px 8px" }}>
          <SectionHeader title="Optional Details" />
        </div>
        <div style={{ padding: "8px" }}>
          <div className="add-pay-request__card-head">
            <span className="add-pay-request__icon-box">
              <DescriptionIcon size={40} />
            </span>
            <span className="add-pay-request__card-title">Description</span>
          </div>

          <TextArea
            value={description}
            onChange={(e) => onDescriptionChange?.(e.value)}
            onBlur={onDescriptionBlur}
            // placeholder="Add a description"
            maxLength={1000}
            rows={4}
            disabled={disabled}
            className="add-pay-request__textarea"
          />

          <div className="add-pay-request__uploader">
            <AttachmentUploader
              files={attachments}
              onFilesAdd={onAttachmentsAdd}
              onRemove={onAttachmentRemove}
              statuses={attachmentStatuses}
              icon={<PaperclipIcon size={40} />}
              hint={`PDF, JPG, PNG upto ${maxSizeMB}MB`}
              maxSizeMB={maxSizeMB}
              disabled={disabled}
            />
          </div>
        </div>
      </CommonCard>
    </section>
  );
};

export default memo(OptionalDetailsSection);
